export default `
mutation updateServiceProviderUser($input: UpdateServiceProviderUserInput!) {
  updateServiceProviderUser(input: $input) {
    coordinates {
      lat
      lng
    }
    officerLevel
    userId
    updatedAt
    displayName
    serviceProviderId
    status
    role
    respondingTo {
      instanceId
      propertyId
    }
    isDeleted
    inRange
  }
}
`;